import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialStateValue = {
  showMandateReturnList: false,
  saveBtnDisable: false,
  filterData: {
    branchValue: null,
    branchTouch: false,
    voucherDate: "",
    voucherDateTouch: false,
    voucherDateDisabled: false,
  },
  gridRows: [],
  gridPaginationData: {
    lastActivePage: 0,
  },
  data: {
    id: "",
    addRecord: false,
    deleteCheckValue: false,
    mandateNum: "",
    mandateDate: null,
    applicationNum: "",
    mandateAmt: "0",
    returnReason: "",
    charges: "0",
    voucherNum: "",
    voucherDate: null,
    branch: "",
    branchCode: "",
    charset: "",
    draweeBank: "",
    draweeBankBranch: "",
    customerName: "",
    customerId: "",
    returnReasonArray: [],
    returnReasonError: false,
    chargesError: false,
    mandateNumError: false,
    mandateNumRecords: [],
    voucherNumArray: [],
    voucherNumTouch: false,
  },
};
const MandateReturnReducer = createSlice({
  name: "mandateReturn",
  initialState: initialStateValue,
  reducers: {
    updateVoucherDateDisabled(state, action) {
      state.filterData.voucherDateDisabled = action.payload;
    },
    updateSaveBtnDisable(state, action) {
      state.saveBtnDisable = action.payload;
    },
    updateShowMandateReturnList(state, action) {
      state.showMandateReturnList = action.payload;
    },
    updateBranchTouchHandler(state, action) {
      state.filterData.branchTouch = action.payload;
    },
    updateVoucherDateTouchHandler(state, action) {
      state.filterData.voucherDateTouch = action.payload;
    },

    updateVoucherNumArray(state, action) {
      state.data.voucherNumArray = action.payload;
    },
    updateVoucherNumTouchHandler(state, action) {
      state.data.voucherNumTouch = action.payload;
    },
    updateVoucherNum(state, action) {
      state.data.voucherNum = action.payload;
    },

    updateReturnReasonTouchHandler(state, action) {
      state.data.returnReasonError = action.payload;
    },

    updateChargesTouchHandler(state, action) {
      state.data.chargesError = action.payload;
    },

    updateReturnReasonArray(state, action) {
      state.data.returnReasonArray = action.payload;
    },

    updateMandateNumErrorHandler(state, action) {
      state.data.mandateNumError = action.payload;
    },

    updateGridRows(state, action) {
      state.gridRows = action.payload;
    },

    updateGridPaginationData(state, action) {
      state.gridPaginationData = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
      state.gridPaginationData.lastActivePage = 0;
    },
    resetFilterValues(state, action) {
      state.filterData.branchValue = null;
      state.filterData.voucherDate = null;
      state.filterData.voucherDateDisabled = false;
    },
    updateBranchValue(state, action) {
      state.filterData.branchValue = action.payload;
    },
    updateVoucherDateValue(state, action) {
      state.filterData.voucherDate = action.payload;
    },

    updateMandateAmt(state, action) {
      state.data.mandateAmt = action.payload;
    },

    updateMandateNumber(state, action) {
      state.data.mandateNum = action.payload;
    },

    updateReturnReason(state, action) {
      state.data.returnReason = action.payload;
    },

    updateCharges(state, action) {
      state.data.charges = action.payload;
    },

    updateMandateNumRecords(state, action) {
      state.data.mandateNumRecords = action.payload;
    },

    updateValues(state, action) {
      state.data.id = action.payload.id;
      state.data.addRecord = action.payload.addRecord;
      state.data.deleteCheckValue = action.payload.deleteCheckValue;
      state.data.mandateNum = action.payload.mandateNum;
      state.data.mandateDate = action.payload.mandateDate;
      state.data.applicationNum = action.payload.applicationNum;
      state.data.mandateAmt = action.payload.mandateAmt;
      state.data.returnReason = action.payload.returnReason;
      state.data.charges = action.payload.charges;
      state.data.voucherNum = action.payload.voucherNum;
      state.data.voucherDate = action.payload.voucherDate;
      state.data.branch = action.payload.branch;
      state.data.branchCode = action.payload.branchCode;
      state.data.charset = action.payload.charset;
      state.data.draweeBank = action.payload.draweeBank;
      state.data.draweeBankBranch = action.payload.draweeBankBranch;
      state.data.customerName = action.payload.customerName;
      state.data.customerId = action.payload.customerId;
      state.data.returnReasonArray = action.payload.returnReasonArray;
      state.data.voucherNumArray = action.payload.voucherNumArray;
    },

    resetValues(state, action) {
      state.data.id = "";
      state.data.addRecord = false;
      state.data.deleteCheckValue = false;
      if (action.payload) {
        // when payload is true means it's reset all for cheque num change or delete.
        // when payload was false reset is called for voucher num -> null
        state.data.mandateNum = "";
        state.data.voucherNum = "";
        state.data.voucherNumArray = [];
        state.data.voucherNumTouch = false;
      } else {
        state.data.voucherNum = "";
        state.data.voucherNumTouch = false;
      }
      state.data.mandateDate = null;
      state.data.applicationNum = "";
      state.data.mandateAmt = "0";
      state.data.returnReason = "";
      state.data.charges = "0";
      state.data.voucherNum = "";
      state.data.voucherDate = null;
      state.data.branch = "";
      state.data.branchCode = "";
      state.data.charset = "";
      state.data.draweeBank = "";
      state.data.draweeBankBranch = "";
      state.data.customerName = "";
      state.data.customerId = "";
      state.data.mandateNumRecords = [];
    },
  },
});
export const MandateReturnReducerAction = MandateReturnReducer.actions;
export default MandateReturnReducer.reducer;
